<template>
    <div>
        <v-btn class="white--text" color="primary" @click="dialog = true" large :disabled="disabled">
            <v-icon>mdi-text-box-outline</v-icon> PDF
        </v-btn>
        <v-dialog v-model="dialog" max-width="1000px">
            <v-card>
                <v-toolbar flat color="primary" dark>
                    <v-toolbar-title>PDF {{ this.title }}</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="dialog = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-0" style="height: 80vh;">
                    <object
                        :data="`${pdfUrl}#view=Fit`"
                        type="application/pdf"
                        frameborder="0"
                        style="width: 100%; height: 100%;"
                    >
                        <a :href="'intent://docs.google.com/viewer?url=' + pdfUrl + '#Intent;scheme=https;package=com.android.chrome;end'" target="_blank" rel="noopener noreferrer">
                            Πατήστε εδώ για άνοιγμα PDF.
                        </a>
                    </object>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        props: {
            pdfUrl: {
                type: String,
                required: true,
                default: () => { return '' }
            },
            disabled: {
                type: Boolean,
                required: true,
                default: () => { return true }
            },
            title: {
                type: String,
                required: true,
                default: () => { return '' }
            }
        },
        data() {
            return {
                dialog: false
            }
        }
    }
</script>
